import Typography from "@material-ui/core/Typography";
import React from "react";
import {multiLanguageValue} from "../../Components/JsonScreen/Utils/lib";
import {useSelector} from "react-redux";

export const ChartTitle = ({hideLabel, size, type, fontStyle, fontWeight, textDecoration, textAlign, title, color, background}) => {
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(title, userLanguage)

    return (
            <div>
                <Typography color={"textPrimary"} style={{
                    fontSize: `${size ? size : 16}${type}`,
                    padding: '0 10px',
                    fontStyle,
                    fontWeight,
                    textDecoration,
                    textAlign,
                    color,
                    background
                }}>
                    {hideLabel ? '' : multiLanguageLabel}
                </Typography>
            </div>
    )
};